export const routes = (prefix = `inventory-management`) => [
    {
        path: `/${prefix}/stock-reorder-level`,
        name: `${prefix}.stock-reorder-level.index`,
        component: () => import('./Reorder_level.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-reorder_level.index`,
                PageDescription: "Inventory management: Stock Reorder Level",
            },
        },
    },{
        path: `/${prefix}/stock-price-list`,
        name: `${prefix}.stock-price-list.index`,
        component: () => import('./PriceList.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-price-list.index`,
                PageDescription: "Inventory management: Stock Price List Level",
            },
        },
    },{
        path: `/${prefix}/stock-with-expiry`,
        name: `${prefix}.stock-with-expiry.index`,
        component: () => import('./ItemWithExpiry.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-with-expiry.index`,
                PageDescription: "Inventory management: Item with Stock Expiry",
            },
        },
    },
    
];
